import React, { useState, useEffect, useRef } from 'react';

function CustomDropdown({options, selected, setSelected, selectedString, setSelectedString}) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (option) => {
    setSelected(option[1]);
    setSelectedString(option[0])
    setOpen(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <div className="relative inline-block w-full" ref={dropdownRef}>
      <div
        className="block w-full px-4 py-2 bg-white border border-gray-300 text-red-500 rounded-md shadow-sm cursor-pointer focus:outline-none"
        onClick={() => setOpen(!open)}
      >
        {selectedString}
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-red-500">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
      {open && (
        <ul className="absolute z-10 mt-1 text-red-500  bg-white border border-gray-300 rounded-md shadow-lg w-full">
          {options.map((option) => (
            <li
              key={option[1]}
              onClick={() => handleSelect(option)}
              className="px-4 py-2 rounded-sm hover:bg-red-500 duration-300 hover:text-white cursor-pointer"
            >
              {option[0]}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default CustomDropdown;
